import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { of, throwError } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';

import {
  entityLocalidadesAllLoadRequest,
  entityLocalidadesLoadFailure,
  entityLocalidadesLoadRequest,
  entityLocalidadesLoadSuccess,

} from './entity-localidades.actions';
import { LocalidadesService } from './entity-localidades.service';
import { entityPersonasJuridicaAddSuccess, entityPersonasJuridicaChangeSuccess } from '../../empresas/entity-personas-juridica/entity-personas-juridica.actions';
import { entityPersonasFisicaAddSuccess, entityPersonasFisicaChangeSuccess } from '../../empresas/entity-personas-fisica/entity-personas-fisica.actions';
import { entityEntidadesProductivaChangeSuccess } from '../../empresas/entity-entidad-productiva/entity-entidades-productiva.actions';
import { entityLaboratoriosAddSuccess } from '../../actividades/entity-laboratorios/laboratorios.actions';
import { entityDepositosAddSuccess } from '../../actividades/entity-depositos/depositos.actions';
import { entityViverosGrupoEspecieAddSuccess } from '../../actividades/entity-viveros-grupo-especie/entity-viveros-grupo-especie.actions';
import { Localidad } from '@rpe/registro-personas-empresas-lib';

@Injectable()
export class LocalidadesEffects {
  // load
  loadRequestLocalidades = createEffect(() =>
    this.actions$.pipe(
      ofType(entityLocalidadesLoadRequest),
      mergeMap((action) =>
        this.localidadesService.getLocalidades(action.q).pipe(
          map((items) => entityLocalidadesLoadSuccess({ items })),
          catchError((error) => of(entityLocalidadesLoadFailure({ error })))
        )
      )
    )
  );

  loadRequestLocalidadesAll = createEffect(() =>
    this.actions$.pipe(
      ofType(entityLocalidadesAllLoadRequest),
      mergeMap((action) =>
        this.localidadesService.getAllLocalidades().pipe(
          map((items) => entityLocalidadesLoadSuccess({ items })),
          catchError((error) => of(entityLocalidadesLoadFailure({ error })))
        )
      )
    )
  );

  localidadesGetRequest = createEffect(() =>
    this.actions$.pipe(
      ofType(
        entityPersonasJuridicaAddSuccess,
        entityPersonasFisicaAddSuccess,
        entityPersonasJuridicaChangeSuccess,
        entityPersonasFisicaChangeSuccess,
        entityEntidadesProductivaChangeSuccess,
        entityLaboratoriosAddSuccess,
        entityDepositosAddSuccess,
        entityViverosGrupoEspecieAddSuccess
      ),
      // Una modificación de "Datos de la Empresa" emite dos acciones en
      // sucesión inmediata (entityPersonas*ChangeSuccess y su mapeo a
      // entityEntidadesProductivaChangeSuccess). Con switchMap la segunda
      // cancelaba el GET en vuelo de la primera (aparecía "cancelado" en la
      // red y la vista quedaba desactualizada). mergeMap deja que cada recarga
      // se complete sin cancelaciones.
      mergeMap(() => {
        return this.localidadesService.getAllLocalidades().pipe(
          map((localidades: Localidad[]) => {
            return entityLocalidadesLoadSuccess({ items: localidades });
          }),
          catchError((error) => of(entityLocalidadesLoadFailure({ error })))
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private localidadesService: LocalidadesService
  ) {
    this.localidadesService.url = environment.apiUrl;
  }
}
